import { render, staticRenderFns } from "./DelegateCount.vue?vue&type=template&id=0b166e3a&"
import script from "./DelegateCount.vue?vue&type=script&lang=ts&"
export * from "./DelegateCount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports